module.exports = __webpack_public_path__ + "static/img/aqzs04.b668e852.jpg";